import FormattedMessage from 'I18n/components/FormattedMessage';
import { useFetchSingleView } from '../hooks/useFetchSingleView';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ViewName = ({
  objectTypeId,
  viewId,
  namespaceName,
  generatedViewName
}) => {
  const {
    data,
    loading,
    error
  } = useFetchSingleView({
    objectTypeId,
    id: viewId,
    namespaceName
  });
  if (error) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.singleViewName.error"
    });
  }
  if (generatedViewName) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: generatedViewName
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.singleViewName.loading"
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: data.singleViewById.name
  });
};